import request from '@/utils/request'

// 获取用户的聊天会话列表
export const getSessionList = (userId) => {
  return request({
    url: `/chat/session/list/${userId}`,
    method: 'get'
  })
}

// 获取客服的聊天会话列表
export const getAdminSessionList = (adminId) => {
  return request({
    url: `/chat/session/admin/list/${adminId}`,
    method: 'get'
  })
}

// 获取会话的聊天消息列表
export const getMessageList = (sessionId) => {
  return request({
    url: `/chat/message/list/${sessionId}`,
    method: 'get'
  })
}

// 发送聊天消息
export const sendMessage = (data) => {
  return request({
    url: '/chat/message/send',
    method: 'post',
    data
  })
}

// 标记消息为已读
export const markAsRead = (sessionId, senderType) => {
  return request({
    url: '/chat/message/read',
    method: 'put',
    params: {
      sessionId,
      senderType
    }
  })
}

// 获取未读消息数量
export const getUnreadCount = (sessionId, senderType) => {
  return request({
    url: '/chat/message/unread/count',
    method: 'get',
    params: {
      sessionId,
      senderType
    }
  })
}

// 关闭聊天会话
export const closeSession = (sessionId) => {
  return request({
    url: `/chat/session/close/${sessionId}`,
    method: 'put'
  })
}

// 分配客服到聊天会话
export const assignAdmin = (sessionId, adminId) => {
  return request({
    url: '/chat/session/assign',
    method: 'put',
    params: {
      sessionId,
      adminId
    }
  })
}

// 获取或创建活跃会话
export const getActiveSession = (userId) => {
  return request({
    url: '/chat/session/active',
    method: 'post',
    params: {
      userId
    }
  })
}